import gql from "graphql-tag";

export const CREATE_SUBSCRIPTION = gql`
  mutation CreateSubscription($isAnnual: Boolean!, $plan: String!) {
    createSubscription(isAnnual: $isAnnual, plan: $plan)
  }
`;

export const CREATE_INITIAL_SUBSCRIPTION = gql`
  mutation CreateInitialPayment($amount: Int!, $isAnnualSubscription: Boolean!, $planName: String!) {
    createInitialPayment(amount: $amount, isAnnualSubscription: $isAnnualSubscription, planName: $planName)
  }
`;

export const UPDATE_SUBSCRIPTION = gql`
  mutation UpdateSubscription($isAnnual: Boolean!, $plan: String!) {
    updateSubscription(isAnnual: $isAnnual, plan: $plan)
  }
`;

export const UPGRADE_OR_DOWNGRADE_SUBSCRIPTION = gql`
  mutation InitUpgradeOrDowngrade($amount: Int!, $isAnnual: Boolean!, $planName: String!) {
    initUpgradeOrDowngrade(amount: $amount, isAnnual: $isAnnual, planName: $planName)
  }
`;

export const DOWNGRADE_SUBS = gql`
  mutation DownGradSubscription($isAnnual: Boolean!, $plan: String!) {
    downGradSubscription(isAnnual: $isAnnual, plan: $plan)
  }
`;
